import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useRole(role) {
    const [hasrole, setHasrole] = useState(null)
    let user = useSelector(state => state.user.user)

    useEffect(() => {
        if (user) {
            setHasrole(user.role === role)
        }
    }, [user])


    return { hasrole }
}